import ChartSeriesProps from './Series'

let KendoChartSeriesItem = {
    name: 'kendo-chart-series-item',
    render () {
        return null
    },
    mixins: [ChartSeriesProps]
}

export default KendoChartSeriesItem


// WEBPACK FOOTER //
// ./packages/kendo-charts-vue-wrapper/src/KendoChartSeriesItem/index.js